import { render, staticRenderFns } from "./BeyondTime.vue?vue&type=template&id=32e3a145&scoped=true&"
import script from "./BeyondTime.vue?vue&type=script&lang=js&"
export * from "./BeyondTime.vue?vue&type=script&lang=js&"
import style0 from "./BeyondTime.vue?vue&type=style&index=0&id=32e3a145&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e3a145",
  null
  
)

export default component.exports